<div class="container-fluid px-0">
  <div class="row  mx-0 my-0 h-100">
    <div class="col-12 px-0 d-flex justify-content-center">
      <img class="info" [src]="'assets/images/secondinfo.png'" [srcset]="'assets/images/secondinfo@2x.png 2x, assets/images/secondinfo@3x.png 3x'" alt="logo"/>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <label class="title">Maalesef işleminize devam edemiyoruz.</label>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class ="description-div">
        <label class="description">Ödeme işlemi yapmak istediğiniz <span class="text-style">ZULA</span> iş yerinde
          sadece
          Faturana Yansıt ile ödeme yapılabiliyor.</label>
        <label class="description">Faturana Yansıt'tan sadece Turkcell aboneleri faydalanabilir. Ödeme işlemine maalesef
          devam edemiyoruz.</label>
      </div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="path"></div>
    </div>
    <div class="col-12 px-0 d-flex justify-content-center">
      <div class="last-info-div">
        <label class="last-info">10 sn. içinde n11.com'a yönlendirileceksiniz. <span
          class="text-style">Siteye git</span></label>
      </div>
    </div>
  </div>
</div>
